import { MembersView } from 'features/organizationMembers/views/MembersView';
import { usePageAnalytics } from 'hooks/useAnalytics';

export const Members = () => {
  usePageAnalytics('OrganizationMembers');

  return <MembersView />;
};
